import React from 'react';
import { Select } from 'antd';

export const GROUP_PREFIX = 'group_';

// TRPA-8695: options for assigning billers / biller groups to doctors and admins.
// Inactive billers and groups stay listed so the user can see them, but they are
// disabled and marked "(Inactive)". Active options come first. Group values are
// prefixed with `group_` so they can share one multi-select with biller ids.
export const renderBillerAssignmentOptions = (billers, billerGroups, excludeGroupId) => {
  const groups = (billerGroups || []).filter(
    g => excludeGroupId === undefined || String(g.id) !== String(excludeGroupId)
  );
  const billerOption = (b, inactive) => (
    <Select.Option key={b.id} value={b.id} disabled={inactive}>
      {inactive ? `${b.fullName} (Inactive)` : b.fullName}
    </Select.Option>
  );
  const groupOption = (g, inactive) => (
    <Select.Option key={`${GROUP_PREFIX}${g.id}`} value={`${GROUP_PREFIX}${g.id}`} disabled={inactive}>
      {inactive ? `${g.groupName} (Inactive)` : g.groupName}
    </Select.Option>
  );
  return [
    ...(billers || []).filter(b => b.isEnabled).map(b => billerOption(b, false)),
    ...groups.filter(g => g.active).map(g => groupOption(g, false)),
    ...(billers || []).filter(b => !b.isEnabled).map(b => billerOption(b, true)),
    ...groups.filter(g => !g.active).map(g => groupOption(g, true))
  ];
};
